<template>
    <div class="recharge_left capital_first">
        <el-card class="box-card common-bg" shadow="never">
            <el-tabs v-model="activeName">
                <el-tab-pane name="accountInfo">
                    <h4 slot="label"> 总账户</h4>
                    <el-card  style="border:1px solid #e3e3e3 !important;padding:15px !important;">
                            <el-row>
                                <el-col :span="4" style="text-align: left;line-height: 30px">
                                    <h3>余额</h3>
                                    <p class="text_red_color">¥ {{ cash }}</p>
                                </el-col>
                                <el-col :span="4" style="text-align: left;margin-top: 5px;margin-left:20px;">
                                    <p>
                                    <router-link to="/myaccount/capital">
                    <el-button type="danger" style="background-color: #D02E27;border:#D02E27;">充值</el-button>
                  </router-link>
                                    <router-link :to="{path:'/myaccount/capital',query:{active:'withdraw'}}">
                    <el-button type="primary" style="background-color: #0D268D;border:#0D268D;">提现</el-button>
                  </router-link>
                  </p>
                                </el-col>
                            </el-row>
                    </el-card>
                </el-tab-pane>
                <el-tab-pane name="bill">
                    <h4 slot="label"> 账单 </h4>
                    <el-card style="border:1px solid #e3e3e3 !important;padding:15px !important;">
                    <div class="recharge_left capital_first">
    <div class="perfect_content">
      <div class="content_declare">
        <ul class="ca_ul2">
          <li>
            <a class="text_blue_color">类型：</a>
          </li>
          <li class="ca_li1">
            <el-button :class="nozzle =='all_log' ? 'back-blue':''" @click="getList('all_log')">全部明细</el-button>
          </li>
          <li class="ca_li1">
            <el-button
              :class="nozzle =='recharge_log' ? 'back-blue':''"
              @click="getList('recharge_log')"
            >充值
            </el-button>
          </li>
          <li class="ca_li1">
            <el-button
              :class="nozzle =='withdraw_log' ? 'back-blue':''"
              @click="getList('withdraw_log')"
            >提现
            </el-button>
          </li>
          <li class="ca_li1">
            <el-button
              :class="nozzle =='loan_log' ? 'back-blue':''"
              @click="getList('loan_log')"
            >借款明细
            </el-button>
          </li>
          <!--<li class="ca_li1">
            <el-button
              :class="nozzle =='loan_log' ? 'back-blue':''"
              @click="getList('loan_log')"
            >结算明细</el-button>
          </li>-->
          <!--<li class="ca_li1">
            <el-button
              :class="nozzle =='extract_log' ? 'back-blue':''"
              @click="getList('extract_log')"
            >利润提取</el-button>
          </li>-->
          <li class="ca_li1">
            <el-button
              :class="nozzle =='manage_log' ? 'back-blue':''"
              @click="getList('manage_log')"
            >管理费用
            </el-button>
          </li>
          <li class="ca_li1">
            <el-button
              :class="nozzle =='vouchermanage_log' ? 'back-blue':''"
              @click="getList('vouchermanage_log')"
            >代金券
            </el-button>
          </li>
          <li class="ca_li1">
            <el-button
              :class="nozzle =='give_back' ? 'back-blue':''"
              @click="getList('give_back')"
            >赠返现金
            </el-button>
          </li>
        </ul>
      </div>
      <div class="content_details">
        <el-table :data="list" size="mini"  height="500" border stripe style="width: 100%">
          <el-table-column prop="time" label="时间" width="200"></el-table-column>
          <el-table-column prop="name" label="类型" width="200"></el-table-column>
          <el-table-column prop="number" label="金额" width="200"></el-table-column>
          <el-table-column prop="balance" label="余额"></el-table-column>
          <el-table-column v-if="nozzle==='recharge_log' || nozzle==='withdraw_log'" prop="status"
                           label="状态"></el-table-column>
        </el-table>

        <div class="text_red_color" style="margin-top: 25px; margin-bottom: 25px; color: red; font-weight: bold;">
          只显示最近12个月记录
        </div>
      </div>
    </div>
  </div>
  </el-card>
                </el-tab-pane>
            </el-tabs>
    
        </el-card>
    
    </div>
    </template>
    
      
    <script>
    export default {
        name: "accountInfo",
        data() {
            return {
                cash: 0.0,
                list: [],
                nozzle: "all_log",
                 page: 1,
                 activeName: "accountInfo",

            }
        },
        computed: {},
        methods: {
            getList(nozzle, type) {
        let that = this;
        if (that.nozzle != nozzle || type == 1) {
          that.nozzle = nozzle;
          if (nozzle === 'give_back') {
            that.$http({
              url: "/",
              method: "post",
              data: {
                nozzle: 'all_log',
                token: sessionStorage.getItem("token"),
                type: 14
              }
            })
              .then(function (res) {
                if (res.data.code == 1) {
                  /*if (res.data.data.length == 0) {
                    that.$message.error("暂无数据");
                  } else {
                    that.list = res.data.data;
                  }*/
                  that.list = res.data.data;
                } else if (res.data.code == 0) {
                  that.$message.error(res.data.msg);
                }
              });
          } else {
            that.$http({
              url: "/",
              method: "post",
              data: {
                nozzle: nozzle,
                token: sessionStorage.getItem("token")
              }
            })
              .then(function (res) {
                if (res.data.code == 1) {
                  /*if (res.data.data.length == 0) {
                    that.$message.error("暂无数据");
                  } else {
                    that.list = res.data.data;
                  }*/
                  if (nozzle === 'recharge_log' || nozzle === 'withdraw_log') {
                    let list = res.data.data.data;
                    if (nozzle === 'recharge_log') {
                      let temp = list;
                      for (let i = 0, len = temp.length; i < len; i++) {
                        switch (temp[i].status) {
                          case 0:
                            temp[i].status = '等待审核';
                            break;
                          case 1:
                            temp[i].status = '充值成功';
                            break;
                          case 2:
                            temp[i].status = '充值失败';
                            break;
                        }
                      }
                      that.list = temp;
                      that.page = res.data.data.page
                    } else {
                      that.list = list;
                    }
                  } else {
                    that.list = res.data.data;
                  }
                } else if (res.data.code == 0) {
                  that.$message.error(res.data.msg);
                }
              });
          }

        }
      },
      handleCurrentChange(page) {
        let that = this;
        let nozzle = that.nozzle;
        if (nozzle === 'recharge_log') {
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: nozzle,
              token: sessionStorage.getItem("token"),
              page: page
            }
          })
            .then(function (res) {
              if (res.data.code == 1) {
                let resData = res.data;
                let temp = resData.data.data;
                for (let i = 0, len = temp.length; i < len; i++) {
                  switch (temp[i].status) {
                    case 0:
                      temp[i].status = '等待审核';
                      break;
                    case 1:
                      temp[i].status = '充值成功';
                      break;
                    case 2:
                      temp[i].status = '充值失败';
                      break;
                  }
                }
                that.page = resData.data.page;
                that.list = temp;
              } else if (res.data.code == 0) {
                that.$message.error(res.data.msg);
              }
            });
        } else if (nozzle === 'withdraw_log') {
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: nozzle,
              token: sessionStorage.getItem("token"),
              page: page
            }
          })
            .then(function (res) {
              if (res.data.code == 1) {
                let resData = res.data;
                that.page = resData.data.page;
                that.list = resData.data.data;
              } else if (res.data.code == 0) {
                that.$message.error(res.data.msg);
              }
            });
        }
      },
          
            getUserinfo() {
                let that = this;
                that.$http({
                        url: "/",
                        method: "post",
                        data: {
                            nozzle: "user",
                            token: sessionStorage.getItem("token")
                        }
                    })
                    .then(function (res) {
                        if (res.data.code == 1) {
                            that.cash = res.data.data.cash;
                        } else if (res.data.code == 0 || res.data.code == -1) {
                            that.$message.error(res.data.msg);
                        }
                    });
            },
          
        },
        mounted() {
            this.getUserinfo();
            let activeTab = this.$route.query.active_tab;
            if (activeTab) {
              this.activeName = activeTab;
            }
            const urlParams = this.$route.query.log;
            const active_tab = urlParams?"vouchermanage_log" : "all_log";
            this.getList(active_tab, 1);
          
        },
    }
    </script>
    
      
    <style scoped>
       /deep/ .el-tabs__item.is-active {
       color: #0D268D !important;
   }
   /deep/ .el-tabs__item:hover {
color: #0D268D !important;
}
/deep/ .el-tabs__active-bar{
background-color:#0D268D !important;
}

/deep/ .el-card__header{
    border-bottom:0px !important;
}


.back-blue {
    background: #566b96 !important;
    color: #fff !important;
  }

  .perfect_title {
    width: 100%;
    height: 70px;
    text-align: left;
    margin-bottom: 50px;
    border-bottom: 1px solid #2b7ea8;
  }

  .perfect_title div {
    text-align: center;
    width: 100px;
    height: 69px;
    line-height: 69px;
    color: #2b7ea8;
    font-weight: 600;
    margin-left: 12px;
    border-bottom: 2px solid #2b7ea8;
  }

  .perfect_content {
    width: 100%;
    margin: 20px auto 0 ;
    padding-bottom: 20px;
  }

  .content_title {
    height: 80px;
    line-height: 100px;
    font-size: 20px;
    text-align: left;
    margin: 0 20px;
    font-weight: 1000;
    border-bottom: 1px solid #ccc;
  }

  .content_declare {
    height: 100px;
    line-height: 40px;
    color: #8388a5;
    font-size: 18px;
    font-weight: 600;
    text-align: left;
    padding-left:120px;
    border-top: 1px solid white;
  }

  /*资金明细*/
  .content_declare > ul:first-child {
    margin-top: 30px;
    margin-bottom: 10px;
  }

  .content_declare > ul > li {
    display: inline-block;
  }

  .content_declare > ul > li:first-child > a {
    padding: 0;
    width: auto;
  }

  .content_declare > ul > li > a {
    display: inline-block;
    color: #000;
    font-size: 16px;
    line-height: 35px;
    width: 85px;
    text-align: center;
    color: #566b96;
  }

  .ca_li_active > a {
    background: #566b96 !important;
    color: #fff !important;
  }

  .content_details {
    width: 960px;
    margin-left: 15px;
    text-align: center;
    padding-left:110px
  }

  .details_title {
    width: 100%;
    height: 55px;
    line-height: 55px;
    text-align: center;
    background-color: #f2f2f2;
  }

  .details_title div {
    display: inline-block;
    width: 8%;
    margin: 0;
    padding: 0;
    color: #444;
  }

  .details_title div:first-child {
    width: 20%;
  }

  .details_title div:last-child {
    width: 30%;
  }

  .content_content {
    width: 960px;
    text-align: center;
  }

  .details_first div {
    width: 8%;
    height: 55px;
    line-height: 55px;
    display: inline-block;
    font-size: 14px;
    color: #999;
  }

  .details_first div:first-child {
    width: 20%;
  }

  .details_first div:last-child {
    width: 30%;
  }

  .M-box2 {
    float: right;
    margin-top: 30px;
  }
  /deep/ .el-button--default:hover {
    color: #0D268D !important;
    border-color: #D0DAF5;
    background-color: #D0DAF5
}
/deep/ .el-button--default.back-blue:hover {
  background: #566b96 !important;
  color: #fff !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/accountInfo.vue